import { render, staticRenderFns } from "./ReportePagosDetallePagos.vue?vue&type=template&id=ab3151b0"
import script from "./ReportePagosDetallePagos.vue?vue&type=script&lang=js"
export * from "./ReportePagosDetallePagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports